export default function TermsPage() {
  return (
    <div className="pt-24 pb-20">
      <div className="max-w-3xl mx-auto px-4 prose prose-invert">
        <h1 className="font-display text-4xl font-black">Terms of Service</h1>
        <p className="text-xs text-slate-500">Last updated: 2026-10-10 · Plain-English template; see your attorney before production use.</p>

        <h2 className="font-display text-2xl font-bold mt-6">1. Who we are</h2>
        <p className="text-slate-300">FLAME Farm & Arcade ("the Service") is an experimental play-to-earn application on the Cronos Mainnet.
          By using the Service you enter into this agreement with the project operator.</p>

        <h2 className="font-display text-2xl font-bold mt-6">2. Eligibility</h2>
        <p className="text-slate-300">You must be at least 18 years old and legally permitted to use blockchain-based games in your
          jurisdiction. The Service is not available to residents of jurisdictions we have blocked at the application layer, including
          but not limited to: the United States, United Kingdom, France, Singapore, mainland China, North Korea, Iran, Syria, Cuba, and
          Russia. Using a VPN to bypass geo-blocking is prohibited.</p>

        <h2 className="font-display text-2xl font-bold mt-6">3. Risk acknowledgement</h2>
        <ul className="text-slate-300 list-disc pl-6">
          <li>FLAME has <b>no guaranteed value</b> and may become worthless.</li>
          <li>CRO sent to the burn wallet (0x…dEaD) is permanently destroyed and cannot be recovered.</li>
          <li>Games include risk-of-loss mechanics. Credits spent cannot be refunded.</li>
          <li>Smart contracts, while audited, can contain bugs. The Service is provided "as is" without warranty.</li>
        </ul>

        <h2 className="font-display text-2xl font-bold mt-6">4. No financial advice</h2>
        <p className="text-slate-300">Nothing on the Service is financial, legal, or tax advice. Consult licensed professionals.</p>

        <h2 className="font-display text-2xl font-bold mt-6">5. Prohibited behavior</h2>
        <p className="text-slate-300">You will not: (a) use the Service for money-laundering or sanctions evasion; (b) attempt to
          exploit smart-contract vulnerabilities; (c) run bots or automated clients; (d) use multiple wallets to game rate limits or
          leaderboards; (e) use the Service from a blocked jurisdiction.</p>

        <h2 className="font-display text-2xl font-bold mt-6">6. No KYC in V1</h2>
        <p className="text-slate-300">Phase 1 does not require identity verification. Future phases may add KYC gated features at the
          operator's discretion.</p>

        <h2 className="font-display text-2xl font-bold mt-6">7. Changes</h2>
        <p className="text-slate-300">The operator may change these terms, pause the claim contract via multi-sig, rotate the trusted
          backend signer, or discontinue the Service. Material changes will be posted on this page.</p>

        <h2 className="font-display text-2xl font-bold mt-6">8. Liability</h2>
        <p className="text-slate-300">To the fullest extent permitted by law, the operator is not liable for loss of CRO, FLAME, credits,
          data, or opportunity resulting from use of the Service.</p>

        <h2 className="font-display text-2xl font-bold mt-6">9. Contact</h2>
        <p className="text-slate-300">Reach the operator at <a href="mailto:ops@flamefarm.app" className="text-cyan-400">ops@flamefarm.app</a>.</p>
      </div>
    </div>
  );
}
